export default __webpack_public_path__ + "static/media/laval7.f00d6d96.jpg";